module.exports = __webpack_public_path__ + "static/img/how2.7ca746d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/how2.png
// module id = +k26
// module chunks = 1